import { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { API_BASE } from "../config";

export default function PowerLogs() {
  const [logs, setLogs] = useState([]);
  const [searchText, setSearchText] = useState("");
  const customStyles = {
    headCells: {
      style: {
        justifyContent: "center", // center header
        textAlign: "center",
        fontWeight: "bold",       // bold text
        fontSize: "16px",   
      },
    },
    cells: {
      style: {
        justifyContent: "center", // center isi cell
        textAlign: "center",
      },
    },
  };

  // Fetch logs
  useEffect(() => {
    fetch(`${API_BASE}/api/power/logs`)
      .then((res) => res.json())
      .then((data) => setLogs(data))
      .catch((err) => console.error("❌ Gagal ambil logs:", err));
  }, []);

  // Filter logs berdasarkan search
  const filteredLogs = logs.filter(
    (log) =>
      (log.time?.toLowerCase() || "").includes(searchText.toLowerCase()) ||
      (log.user?.toLowerCase() || "").includes(searchText.toLowerCase()) ||
      (log.status?.toLowerCase() || "").includes(searchText.toLowerCase()) ||
      (log.device?.toLowerCase() || "").includes(searchText.toLowerCase())
  );
  // Fungsi format waktu
  const formatTime = (time) => {
    if (!time) return "-";
    const date = new Date(time);
    return date.toLocaleString("id-ID", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  };
  // Definisi kolom
  const columns = [
    {
      name: "Time",
      selector: (row) => formatTime(row.time),
      sortable: true,
    },
    {
      name: "User",
      selector: (row) => row.user,
      sortable: true,
    },
    {
      name: "Device",
      selector: (row) => row.device,
      sortable: true,
    },
    {
      name: "Action",
      selector: (row) => row.action,
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => row.status,
      sortable: true,
      cell: (row) => (
        <span
          className={`px-2 py-1 rounded-lg font-medium text-sm ${
            row.status === "Granted" ? "bg-green-100 text-green-600" : "bg-red-100 text-red-600"
          }`}
        >
          {row.status}
        </span>
      ),
    },
  ];

  return (
    <div className="p-2">
        <h2 className="text-2xl font-bold mb-4 text-center">Access Logs</h2>
        
      {/* Search bar */}
      <div className="mb-4 flex justify-end">
        <input
          type="text"
          placeholder="🔍 Search Time, User, Device or Status..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          className="border px-4 py-2 rounded w-96"
        />
        {searchText && (
          <button
            onClick={() => setSearchText("")}
            className="ml-2 px-3 py-1 bg-gray-300 rounded"
          >
            Clear
          </button>
        )}
      </div>

      <DataTable
        columns={columns}
        data={filteredLogs}
        pagination
        highlightOnHover
        responsive
        dense
        customStyles={customStyles}

      />
    </div>
  );
}
